//import { essGet, essPatch, essPut, notificationGet } from "../api/api";
import { essGet, essPatch, essPut } from "../api/api";

export const notificationService = {
  //getRecords({ page = 0, size = 10, unreadOnly = true, type = "*" } = {}) {
  getRecords({ page = 0, size = 10, unreadOnly = true} = {}) {
    const query = new URLSearchParams({
      page: String(page),
      size: String(size),
      unreadOnly: String(unreadOnly),
    });
    //return notificationGet(`/notification/records/my?${query.toString()}`);
    return essGet(`/notification/my?${query.toString()}`);
  },
  getUnreadCount() {
    return essGet("/notification/my/unread-count");
  },
  update(notificationId, body) {
    return essPut(`/notification/update/${encodeURIComponent(notificationId)}`, body);
  },
  markViewed(notificationId) {
    return essPatch(`/notification/mark-viewed/${encodeURIComponent(notificationId)}`);
  },
  markAllViewed() {
    return essPatch("/notification/mark-all-viewed");
  },
  delete(notificationId) {
    //return essDel(`/notification/delete/${encodeURIComponent(notificationId)}`);
    return essPatch(`/notification/delete/${encodeURIComponent(notificationId)}`);
  },
  deleteAll() {
    //return essDel(`/notification/delete/${encodeURIComponent(notificationId)}`);
    return essPatch(`/notification/delete-all`);
  },
};
